import React from "react";
import { Form } from "semantic-ui-react";


const ProductFieldDropdown = ({ name, title, options, context, ...args }) => (
    <div>
        <Form.Dropdown
            value={context.state.product[name]}
            fluid
            label={title}
            selection
            options={options}
            onChange={(e, { value }) => {
                context.setState(({ product }) => ({
                    product: {
                        ...product,
                        [name]: value
                    },
                    validated: false
                }));
                context.dValidate();
            }}
            {...args}
        />
    </div>
);

export default ProductFieldDropdown;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/ProductFieldDropdown/index.js